import { t } from './i18n';

/**
 * 设置页面标题
 * @param {string} titleKey - i18n翻译key或直接标题
 */
export const setPageTitle = (titleKey) => {
  if (!titleKey) {
    document.title = 'Blue API';
    return;
  }
  // 如果包含下划线，视为i18n key
  if (titleKey.includes('_')) {
    const title = t(titleKey);
    // 使用翻译值或原始key作为fallback
    const displayTitle = title && title !== titleKey ? title : titleKey.replace(/_/g, ' ');
    document.title = `${displayTitle} - Blue API`;
  } else {
    // 直接设置标题
    document.title = titleKey;
  }
};

/**
 * 设置简单页面标题（不包含网站名称）
 * @param {string} titleKey - i18n翻译key
 */
export const setDocumentTitle = (titleKey) => {
  const title = t(titleKey);
  document.title = title || 'Blue API';
};

export default { setPageTitle, setDocumentTitle };
